module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_decollte_logo_white-1b413db6971c295337607aca4ab9d887.svg";